//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      dialoginvestimento: false,
    }
  },
  props: [
    'descricao',
    'duracao',
    'inicio',
    'modalidade',
    'carga_horaria',
    'investimento',
    'inscricao',
    'parceiros',
    'titulo',
    'slug',
    'type',
    'months',
    'turmasLength',
    'video',
  ],
  methods: {
    openCalendar() {
      this.$nuxt.$emit('open-calendar')
    },
    fazerPonto(valor) {
      if (valor.toString().length > 3) {
        let ultimos = valor
          .toString()
          .slice(valor.toString().length - 3, valor.toString().length)
        let primeiros = valor.toString().slice(0, valor.toString().length - 3)

        return primeiros + '.' + ultimos
      } else {
        return valor
      }
    },
  },
  computed: {
    menorPreco(v) {
      if (v.investimento) {
        let min = Math.min(...v.investimento.map((item) => item.valor))
        let result = v.investimento.filter((item) => item.valor === min)
        return result[0]
      }
    },
    menorPrecoLabel(v) {
      return v.menorPreco?.label
    },
    menorPrecoValor(v) {
      return v.menorPreco?.valor
    },
  },
}
